export const authURL = "https://auth.maxiv.lu.se/v1/decode";
export const loginURL = "https://auth.maxiv.lu.se/login";